import React from 'react';
import {getRainClass, getRainIndicator} from '../../../utils/helpers';

const RainRow = ({dayData, units, data}) => {

    return (
        <tr className="hover:bg-custom-darker/50 transition-colors">
            <td className="pl-2 py-1 text-xs text-custom-light-grey ">
                <div className="inline-flex items-center gap-2 font-medium">
                    <div>
                        <span className="block">Rain</span>
                        {units && <span className="text-custom-light-grey/70">({units})</span>}
                    </div>
                </div>
            </td>
            {dayData.map(({ index }) => {
                const rain = data?.[index];
                const rainClass = getRainClass(rain);
                const rainIndicator = getRainIndicator(rain);
                return (
                    <td key={index} className="py-1 text-center">
                        <div className="inline-flex flex-col items-center gap-1">
                            {/* <div className="flex justify-center">{rainIndicator}</div> */}
                            <div className={`inline-block min-w-[30px] text-center text-sm font-medium ${rainClass}`}>
                                {rain}
                            </div>
                        </div>
                    </td>
                );
            })}
        </tr>
    )
}

export default RainRow;